const appconstant = {
  serverError: "Something went wrong",
  changepassword: "Change Password",
  Oldpassword: "Old Password",
  NewPassword: "New Password",
  ConfirmNewPassword: "Confirm New Password",
  home: "Dashboard",
  view: "View",
  edit: "Edit",
  block: "Block",
  universityOfBrighton: "University of Brighton",
  name: "Name",
  description: "Description",
  addTitle: "Add Title",
  selectDate: "Select Date",
  selectTime: "Select Time",
  email: "Email",
  password: "Password",
  organizationName: "Organization Name",
  departmentsName: "Department Name",
  like: "Like",
  comment: "Comment",
  startDate: "Start Date",
  expiryDate: "Expiry Date",
  phone: "Phone",
  plan: "Plan",
  addUser: "Add User",
  accountEmail: "Account Email",
  noDays: "No of Days",
  message: "Message",
  guidelines: "Guidelines",
  entertainment: "Entertainment",
  suggestedActivities: "Suggested Activities",
  activityTitle: "Activity Title",
  activityDetail: "Activity Detail",
  postSuggestions: "Post Suggestions",
  title: "Title",
  detail: "Detail",
  gratitudeAttitude: "Gratitude Attitude",
  enGroupTitle: "Encouragement Group Title",
  enGroupDetail: "Encouragement Group Details",
  messageDescription: "Message Description",
  reject: "Reject",
  approve: "Approve",
  rejectionReason: "Rejection Reason",
  profileDetail: "Profile Details",
  problemType: "Problem Type",
  widgetTitle: "Widget Title",
  linkTo: "Link To",
  firstName: "First Name",
  lastName: "Last Name",
  rankName: "Rank Name",
  rankRuleDetail: "Rank Rule Detail",
  queryDetail: "Query Detail",
  logMood: "Log Mood",
  emotionTitle: "Emotion Title",
  logThought: "Log Thought",
  thoughtTitle: "Thought Title",
  meditation: "Meditation",
  meditationTitle: "Meditation Title",
  meditationDetail: "Meditation Detail",
  uploadIcons: "Upload Icons",
  playlists: "Playlists",
  videoTitle: "Video Title",
  addTags: "Add Tags",
  quote: "Quote",
  articles: "Articles",
  meditationDetail: "Meditation Detail",
  guidelines: "Guidelines",

  //

  //

  // Navbar text
  dashboard: "Dashboard",
  users: "Users",
  innerCircle: "Inner Circle",
  who5Assement: "WHO5 Assessment",
  setting: "Settings",

  //Dashboard text

  welcome: "Welcome",

  //card-text

  signups: "Sign Ups",
  totalengagement: "Total Engagement",
  comunityposts: "Community Posts",
  moodlogged: "Moods Logged",
  thoughtslogged: "Thoughts Logged",
  totalappointment: "Total Appointments",

  //dashboard total usage

  logmood: "Log Mood",
  logthought: "Log Thought",
  community: "Community",
  encouragmentGroup: "Encouragement Group",
  innerCircle: "Inner Circle",
  journaling: "Journaling",
  affirmation: "Affirmation",
  meditation: "Meditation",
  directCare: "Direct Care",

  //Direct Care

  noOfAppointment: "No. of Appointments",
  totalBookings: "Total Bookings",
  appeared: "Appeared",
  therapist: "Therapist",

  //sign ups:

  signups: "Sign Ups",
  basedOnTheGender: "(Based on Gender)",
  gender: "Gender",
  male: "Male",
  feMale: "Female",
  total: "Total",
  signup: "Sign Up",

  //Welness

  whoWellnessIndex: "WHO-5 Wellness Index",
  memberSubmiited: "Members submitted.",
  WellnessActivitiesParticipation: "Wellness Activities Participation",
  nofparticipent: "Number of Participants",
  activity: "Activity",
  noOfPosts: "No of Posts",
  engagement: "Engagement Rate",
  noOfComment: "No of comments",

  //login

  loginWithEmail: "Login with your Email",
  Email: "Email",
  password: "Password",
  enterYourEmail: "Enter your email",
  enterYourPassword: "Enter your pssword",
  rememberMe: "Remember me",
  forgotPassword: "Forgot Password?",
  metafitRights: "MentalFit© 2024 All Rights Reserved.",

  //forgot

  forgotYourPassword: "Forgot your password?",
  forgotText:
    "Please enter your email below and we will  send you instructions to reset your username",
  submit: "Submit",

  //instruction

  instructionSent: "Instructions have been sent to your email ",
  instructionText1: "We have sent the instructions to your email.",
  instructionText2: "lorem ipsum dolor imit lorem ipsum ",

  //new-password

  createNewPassword: "Create new password",
  passwordText:
    "Please enter your email below and we will  send you instructions to reset your username",
  passwordPlaceHolder: "Password",
  retypePasswordPlaceHolder: "Retype Password",

  //new-password-created

  newPasswordCreated: "New Password created!",
  password: "Password",
  retypePassword: "Retype Password",

  //Dashboard

  WellnessActivitiesParticipation: "Wellness Activities Participation",
  noOFParticipation: "Number of Participants",
  journaling: "Journaling",
  Affirmation: "Affirmation",
  medidation: "Medidation",

  // average-mood

  averageMood: "Average Mood",
  currentvsprevious: "Current vs Previous",
  moodlogs: "Mood Logs",

  // inner-circle

  createInnerCircle: "Create Inner Circle",
  innerCircleText:
    "Sed consecte tur imper lla males ua daSr lla males ua daSr lla males ua daSed consectetur. ",
  innerName: "Name",
  description: "Description",
  innerPlaceholder: "Enter description ",
  createInnerText: "Create Inner Circle",

  //create-inner_circle

  importYourCircle: "Import People to your Circle",
  importCircleText: "You can always Invite more People later !",
  importCircleBtnText: "Click here to upload",

  //inner-bar

  mostActiveMember: "Most Active Members",
  entertainment: "Entertainment",
  entertainmentText: "Circle activity tomorrow at 10:00 AM",
  engagementRate: "Engagement Rate",

  //innerCircle

  innerCircle: "Inner Circle",
  myInnerCircle: "My Inner Circle",

  // custom Activity

  createCustomActivity: "Create Custom Activity",
  customActivityText:
    "Sed consecte tur imper lla males ua daSr lla males ua daSr lla males ua daSed consectetur. ",
  addTitle: "Add Title",
  selectDate: "Select Date",
  selectTime: "Select Time",
  customDescription: "Description",
  customInnerText:
    "Sed consecte tur imper lla males ua daSr lla males ua daSr lla males ua daSed consectetur. ",

  //schedule Activitvites:

  scheduledActivites: "Scheduled Circle Activities",
  noActivityYet: "No Activity Yet",
  sheduleDescription: "This is a short activity description",
  createActivity: "Create Activity",

  myInnerCircle: "My Inner Circle",
  accountDetail: "Account Details",

  accountDetailText:
    "Sed consectetur imperdiet facilisiulla malesua daeddiet facilisiulla malesua daed",

  //users

  users: "Users",
  userText:
    "Sed consectetur imperdiet facilisiulla malesua daeddiet facilisiulla malesua daed",
  addUser: "Add User",
  who5Assement: "WHO5 Assessment",
  upcomingAssement: "Upcoming Assessment Date: ",

  //modal Text

  requestAssement: "Request Assessment",
  requestAssementText:
    "Sed consecte tur imper lla males ua daSr lla males ua daSr lla males ua daSed consectetur. ",
  schedule: "Schedule WHO5 Assessment",
  scheduleText:
    "Sed consecte tur imper lla males ua daSr lla males ua daSr lla males ua daSed consectetur. ",

  //Who-5

  who5Score: "WHO-5 Score",
  sentTo: "Sent to:",
  submissions: "Submissions",

  //Add User
  addUser: "Add User",
  addUserText: "Sed consecte tur imper lla males ua daSr lla males ua ",
  addUserText2: "daSr lla males ua daSed consectetur.",
  addUserBtnText: "Click here to upload",
  assessmentDate: "Upcoming Assessment Date:",
  noOfPeople: "No of People",

  //Navbar Logout

  navbarLogout: "Log out",

  //
  buttonupate: "Update",
};
// accessRoutesArray

export const accessArray = [
  {
    name: "change password",
    route: "/change-password",
    default: true,
  },
  {
    name: "logout",
    route: "/logout",
    default: true,
  },
  {
    name: "organisation-list",
    route: "/organisation-list",
    default: true,
  },
  {
    name: "create-org-admin",
    route: "/create-org-admin",
    default: true,
  },
  {
    name: "org-admin-list",
    route: "/org-admin-list",
    default: false,
  },
  {
    name: "all-mood-logged",
    route: "/all-mood-logged",
    default: true,
  },
  {
    name: "all-thoughts-logged",
    route: "/all-thoughts-logged",
    default: true,
  },
  {
    name: "get-average-log",
    route: "/get-average-log",
    default: true,
  },
  {
    name: "top-usage",
    route: "/top-usage",
    default: true,
  },
  {
    name: "user-list",
    route: "/user-list",
    default: true,
  },
  {
    name: "account-status",
    route: "/account-status",
    default: true,
  },
  {
    name: "core-value-status",
    route: "/core-value-status",
    default: true,
  },
  {
    name: "get-user-detail",
    route: "/get-user-detail",
    default: true,
  },
  {
    name: "circle-detail",
    route: "/circle-detail",
    default: true,
  },
  {
    name: "freeze-profile",
    route: "/freeze-profile",
    default: true,
  },
  {
    name: "post-list",
    route: "/post-list",
    default: true,
  },
  {
    name: "create-post",
    route: "/create-post",
    default: true,
  },
  {
    name: "comment-on-post",
    route: "/comment-on-post",
    default: true,
  },
  {
    name: "post-comment-list",
    route: "/post-comment-list",
    default: true,
  },
  {
    name: "upload-avatar",
    route: "/upload-avatar",
    default: true,
  },
  {
    name: "email-search",
    route: "/email-search",
    default: true,
  },
  {
    name: "report-detail",
    route: "/report-detail",
    default: true,
  },
  {
    name: "delete",
    route: "/delete",
    default: true,
  },
  {
    name: "who-score",
    route: "/who-score",
    default: true,
  },
  {
    name: "remove-post",
    route: "/remove-post",
    default: true,
  },
  {
    name: "remove-inner-circle",
    route: "/remove-inner-circle",
    default: true,
  },
  {
    name: "inner-circle-detail",
    route: "/inner-circle-detail",
    default: false,
  },
  {
    name: "encouragement/create-group",
    route: "/encouragement/create-group",
    default: true,
  },
  {
    name: "encouragement/group-list",
    route: "/encouragement/group-list",
    default: true,
  },
  {
    name: "encouragement/group-post-list",
    route: "/encouragement/group-post-list",
    default: true,
  },
  {
    name: "contact-us-list",
    route: "/contact-us-list",
    default: true,
  },
  {
    name: "encouragement/edit-group",
    route: "/encouragement/edit-group",
    default: true,
  },
  {
    name: "active-admin-account",
    route: "/active-admin-account",
    default: true,
  },
  {
    name: "request-assesment",
    route: "/request-assesment",
    default: true,
  },
  {
    name: "delete-admin-account",
    route: "/delete-admin-account",
    default: true,
  },
  {
    name: "create-schedule-notification",
    route: "/create-schedule-notification",
    default: true,
  },
  {
    name: "schedule-notification-list",
    route: "/schedule-notification-list",
    default: true,
  },
  {
    name: "inner-circle-count",
    route: "/inner-circle-count",
    default: false,
  },
  {
    name: "create-sub-admin",
    route: "/create-sub-admin",
    default: true,
  },
  {
    name: "sub-admin-list",
    route: "/sub-admin-list",
    default: true,
  },
  {
    name: "ignore-report",
    route: "/ignore-report",
    default: true,
  },
  // Admin
  {
    name: "create-organisation",
    route: "/create-organisation",
    default: true,
  },
  {
    name: "organisation-list",
    route: "/organisation-list",
    default: true,
  },
  {
    name: "create-org-admin",
    route: "/create-org-admin",
    default: true,
  },
  {
    name: "org-admin-list",
    route: "/org-admin-list",
    default: true,
  },
  {
    name: "all-mood-logged",
    route: "/all-mood-logged",
    default: true,
  },
  {
    name: "all-thoughts-logged",
    route: "/all-thoughts-logged",
    default: true,
  },
  {
    name: "get-average-log",
    route: "/get-average-log",
    default: true,
  },
  {
    name: "top-usage",
    route: "/top-usage",
    default: true,
  },
  {
    name: "user-list",
    route: "/user-list",
    default: true,
  },
  {
    name: "account-status",
    route: "/account-status",
    default: true,
  },
  {
    name: "core-value-status",
    route: "/core-value-status",
    default: true,
  },
  {
    name: "circle-detail",
    route: "/circle-detail",
    default: true,
  },
  {
    name: "freeze-profile",
    route: "/freeze-profile",
    default: true,
  },
  {
    name: "post-list",
    route: "/post-list",
    default: true,
  },
  {
    name: "create-post",
    route: "/create-post",
    default: true,
  },
  {
    name: "comment-on-post",
    route: "/comment-on-post",
    default: true,
  },
  {
    name: "post-comment-list",
    route: "/post-comment-list",
    default: true,
  },
  {
    name: "report-list",
    route: "/report-list",
    default: false,
  },
  {
    name: "report-data",
    route: "/report-data",
    default: false,
  },
  {
    name: "upload-avatar",
    route: "/upload-avatar",
    default: true,
  },
  {
    name: "email-search",
    route: "/email-search",
    default: true,
  },
  {
    name: "report-detail",
    route: "/report-detail",
    default: false,
  },
  {
    name: "delete",
    route: "/delete",
    default: true,
  },
  {
    name: "get-inner-circle-list",
    route: "/get-inner-circle-list",
    default: false,
  },
  {
    name: "get-inner-circle",
    route: "/get-inner-circle",
    default: false,
  },
  {
    name: "circle-post-list",
    route: "/circle-post-list",
    default: false,
  },
  {
    name: "who-score",
    route: "/who-score",
    default: true,
  },
  {
    name: "remove-post",
    route: "/remove-post",
    default: false,
  },
  {
    name: "remove-inner-circle",
    route: "/remove-inner-circle",
    default: false,
  },
  {
    name: "encouragement/create-group",
    route: "/encouragement/create-group",
    default: true,
  },
  {
    name: "encouragement/group-list",
    route: "/encouragement/group-list",
    default: true,
  },
  {
    name: "encouragement/group-post-list",
    route: "/encouragement/group-post-list",
    default: true,
  },
  {
    name: "contact-us-list",
    route: "/contact-us-list",
    default: true,
  },
  {
    name: "encouragement/edit-group",
    route: "/encouragement/edit-group",
    default: true,
  },
  {
    name: "active-admin-account",
    route: "/active-admin-account",
    default: true,
  },
  {
    name: "get-access",
    route: "/get-access",
    default: true,
  },
  //
  {
    name: "dashboard",
    route: "/dashboard",
    default: true,
  },
  {
    name: "signups-gender-based",
    route: "/signups-gender-based",
    default: true,
  },
  {
    name: "get-moods-logged",
    route: "/get-moods-logged",
    default: true,
  },
  {
    name: "get-thoughts-logged",
    route: "/get-thoughts-logged",
    default: true,
  },
  {
    name: "get-post-activity",
    route: "/get-post-activity",
    default: true,
  },
  {
    name: "get-wellness-activity",
    route: "/get-wellness-activity",
    default: true,
  },
  {
    name: "create-inner-circle",
    route: "/create-inner-circle",
    default: true,
  },
  {
    name: "add-user-in-circle",
    route: "/add-user-in-circle",
    default: true,
  },
  {
    name: "add-user-csv",
    route: "/add-user-csv",
    default: true,
  },
  {
    name: "create-activity",
    route: "/create-activity",
    default: true,
  },
  {
    name: "who-willness-index",
    route: "/who-willness-index",
    default: true,
  },
];

export default appconstant;
